export function adaptContactPrefill(response, makeId) {
  if (response?.success !== true || response.schema_version !== 'contact_prefill.v1' ||
      !Array.isArray(response.contacts) || response.contacts.length > 50) {
    throw new Error('INVALID_CONTACT_DRAFT');
  }
  const stringValue = (value) => typeof value === 'string' ? value.trim() : '';
  const candidates = response.contacts.map((source) => {
    if (!source || typeof source !== 'object' || Array.isArray(source)) {
      throw new Error('INVALID_CONTACT_DRAFT');
    }
    return {
      id: makeId(),
      contact_first_name: stringValue(source.first_name),
      contact_last_name: stringValue(source.last_name),
      email: stringValue(source.email).toLowerCase(),
      phone: stringValue(source.phone),
      confidence: Number.isFinite(source.confidence) ? source.confidence : 0,
      inferredFields: Array.isArray(source.inferred_fields) ? source.inferred_fields.filter((field) =>
        ['first_name', 'last_name', 'email', 'phone'].includes(field)) : [],
      excerpt: stringValue(source.source_excerpt),
      warnings: Array.isArray(source.warnings) ? source.warnings.filter((value) => typeof value === 'string') : [],
    };
  });
  return {
    requestId: stringValue(response.request_id),
    warnings: Array.isArray(response.warnings) ? response.warnings.filter((value) => typeof value === 'string') : [],
    candidates,
  };
}

function contactKeys(contact) {
  const email = String(contact.email || '').trim().toLowerCase();
  let digits = String(contact.phone || '').replace(/\D/g, '');
  if (digits.length === 10) digits = `1${digits}`;
  const first = String(contact.contact_first_name ?? contact.first_name ?? '').trim().toLowerCase();
  const last = String(contact.contact_last_name ?? contact.last_name ?? '').trim().toLowerCase();
  return { email, phone: digits, name: first && last ? `${first}|${last}` : '' };
}

export function applyContactCandidates(previous, candidates, selectedIds, existingContacts = []) {
  const contacts = [...previous];
  const skipped = [];
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  for (const candidate of candidates) {
    if (!selectedIds.includes(candidate.id)) continue;
    const keys = contactKeys(candidate);
    if (!candidate.contact_first_name?.trim() || !candidate.contact_last_name?.trim() ||
        !emailPattern.test(candidate.email || '') ||
        (candidate.phone && !/^\+[1-9]\d{6,14}$/.test(candidate.phone))) {
      skipped.push({ id: candidate.id, reason: 'Complete names and a valid email/phone before applying' });
      continue;
    }
    const collision = [...contacts, ...existingContacts].some((contact) => {
      const other = contactKeys(contact);
      return (keys.email && keys.email === other.email) ||
        (keys.phone && keys.phone === other.phone) || (keys.name && keys.name === other.name);
    });
    if (collision) {
      skipped.push({ id: candidate.id, reason: 'Possible duplicate: review the existing contact manually' });
      continue;
    }
    const row = {
      id: candidate.id,
      contact_first_name: candidate.contact_first_name.trim(),
      contact_last_name: candidate.contact_last_name.trim(),
      contact_type_id: '',
      contact_status_type_id: '',
      email: candidate.email.trim().toLowerCase(),
      phone: candidate.phone,
      title: '',
      createUserAccount: false,
      userRoleId: '',
      targetProviderId: '',
    };
    const blankIndex = contacts.findIndex((contact) =>
      ![contact.contact_first_name, contact.contact_last_name, contact.email, contact.phone,
        contact.title, contact.contact_type_id, contact.createUserAccount, contact.userRoleId,
        contact.targetProviderId]
        .some((value) => typeof value === 'string' ? value.trim() !== '' : Boolean(value)));
    if (blankIndex >= 0) contacts[blankIndex] = {
      ...row, contact_status_type_id: contacts[blankIndex].contact_status_type_id || '',
    };
    else contacts.push(row);
  }
  return { contacts, skipped };
}
